import { useMutation } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import type { SeatRequestAcceptedData } from "@/hooks/queries/seat-request-types";

// POST /org-admin/seat-requests (Story 14.7, gh-171; FR77 + FR78) — the
// one-step "Request additional seats" CTA firing the Story 13.7 SMTP path.
// 202 means the canonical email to the AMPS Director role inbox is queued;
// NO DB record exists (FR78 — the email IS the record), so success invalidates
// nothing. Backend error contract: 429 ORG-004 per-user rate limit
// (3 / 15 min, Retry-After) and 409 ORG-002 when the org_admin's claim
// resolves to no professional org. A post-session call — it rides apiFetch's
// silent-refresh path (skipAuthRefresh deliberately omitted).

/**
 * The mutationKey + `gcTime: Infinity` keep a successful request in the
 * mutation cache for the whole SPA session: the dashboard derives its
 * disabled-CTA / confirmation-banner state via useMutationState, so the
 * FR77 "disabled for the remainder of the session" guard survives route
 * navigation and is wiped by the sign-out chokepoint (auth-context calls
 * queryClient.clear()). A full reload resets it — accepted: the backend
 * rate limiter is the other half of the guard (13.7, PR #514).
 */
export const SEAT_REQUEST_MUTATION_KEY = ["org-admin", "seat-request"] as const;

export function useRequestAdditionalSeats() {
  return useMutation({
    mutationKey: SEAT_REQUEST_MUTATION_KEY,
    gcTime: Infinity,
    mutationFn: () =>
      apiFetch<SeatRequestAcceptedData>("/org-admin/seat-requests", {
        method: "POST",
      }),
  });
}
